<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Organisasi Pengadaan" back_url="organisasi_pengadaan"/>
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="paket_pengadaan_id" class="col-12 mb-2 md:col-2 md:mb-0">Paket Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <Dropdown class="w-full md:w-14rem" v-model="form.paket_pengadaan_id" :options="daftar_paket_pengadaan" optionLabel="nama_paket_pengadaan" placeholder="Pilih Paket Pengadaan" required="required" >
                                <template #option="slotProps">
                                    <div class="country-item">
                                        <div>{{slotProps.option.nama_paket_pengadaan}}</div>
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="errors.paket_pengadaan_id" id="name-help" class="p-error">Paket Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ttpp_id" class="col-12 mb-2 md:col-2 md:mb-0">Tim Teknik Perencanaan Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ttpp_id" type="text" :class="{'p-invalid' : errors.ttpp_id}" v-model="form.ttpp_id" />
                            <small v-if="errors.ttpp_id" id="name-help" class="p-error">Tim Teknik Perencanaan Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ttpk_id" class="col-12 mb-2 md:col-2 md:mb-0">Tim Teknis Pelaksanaan Kontrak</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ttpk_id" type="text" :class="{'p-invalid' : errors.ttpk_id}" v-model="form.ttpk_id" />
                            <small v-if="errors.ttpk_id" id="name-help" class="p-error">Tim Teknis Pelaksanaan Kontrak Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="pp_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <Dropdown class="w-full md:w-14rem" v-model="form.pp_id" :options="daftar_pp" optionLabel="fullname" placeholder="Pilih Pejabat Pengadaan" required="required" >
                                <template #option="slotProps">
                                    <div class="country-item">
                                        <div>{{slotProps.option.fullname}}</div>
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="errors.pp_id" id="name-help" class="p-error">PP Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="pphp_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Penerima Hasil Pekerjaan</label>
                        <div class="col-12 md:col-10">
                            <Dropdown class="w-full md:w-14rem" v-model="form.pphp_id" :options="daftar_pphp" optionLabel="fullname" placeholder="Pilih Pejabat Penerima Hasil Pekerjaan" required="required" >
                                <template #option="slotProps">
                                    <div class="country-item">
                                        <div>{{slotProps.option.fullname}}</div>
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="errors.pphp_id" id="name-help" class="p-error">PPHP Wajib Diisi</small>
                        </div>
                    </div>
                </template>  
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2" @click="submitForm()"/>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import {FilterMatchMode} from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import PermissionTreeTable from "../../Components/PermissionTreeTable";
import MenuTreeTable from "../../Components/MenuTreeTable";
import Dropdown from 'primevue/dropdown';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column, 
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        PermissionTreeTable,
        MenuTreeTable,
        Dropdown,
    },
    props : {
        errors : Array,
        daftar_paket_pengadaan : Array,
        daftar_pokja : Array,
        daftar_pp : Array,
        daftar_pphp : Array,
    },
    data : function(){
        return {
                form : {
                    name : '',
                    permissions : [],
                    menus : [],
                },
            }
    },
    methods : {
        submitForm(){
            // alert(this.form)
            Inertia.post('/organisasi_pengadaan/', this.form);
        }
    }
}
</script>
